<template>
    <Modal :show-footer="false" :show-title="false" design="v3" @cancel="cancel">
        <div class="extra-plan-content">
            <div class="header-section">
                <div class="icon-wrapper">
                    <i class="material-icons">shopping_cart</i>
                </div>
            <div class="title">{{ $t("message.buyExtraChatbot") }}</div>
                <div class="subtitle">{{ $t("message.selectSessionPackage") }}</div>
            </div>

            <div class="suggestion-sessions">
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 1000 && 'selected']"
                    @click="sessionCount = 1000"
                >
                    {{ $t("message.extraPlanSessionLabel1k") }}
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 5000 && 'selected']"
                    @click="sessionCount = 5000"
                >
                    {{ $t("message.extraPlanSessionLabel5k") }}
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 10000 && 'selected']"
                    @click="sessionCount = 10000"
                >
                    {{ $t("message.extraPlanSessionLabel10k") }}
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 20000 && 'selected']"
                    @click="sessionCount = 20000"
                >
                    {{ $t("message.extraPlanSessionLabel20k") }}
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 50000 && 'selected']"
                    @click="sessionCount = 50000"
                >
                    {{ $t("message.extraPlanSessionLabel50k") }}
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 100000 && 'selected']"
                    @click="sessionCount = 100000"
                >
                    {{ $t("message.extraPlanSessionLabel100k") }}
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 250000 && 'selected']"
                    @click="sessionCount = 250000"
                >
                    {{ $t("message.extraPlanSessionLabel250k") }}
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 1000000 && 'selected']"
                    @click="sessionCount = 1000000"
                >
                    {{ $t("message.extraPlanSessionLabel1m") }}
                </div>
            </div>

            <div class="custom-input-section">
                <div class="input-container">
                    <div class="input-wrapper">
                        <div class="input-icon">
                            <i class="material-icons">edit</i>
                        </div>
                        <div class="input-content">
                            <div class="input-label">{{ $t("message.customSessionAmount") }}</div>
                            <a-input-number
                                v-model="sessionCount"
                                :min="1"
                                :max="10000000"
                                :placeholder="$t('message.enterAmount')"
                                class="custom-input"
                            />
                        </div>
                    </div>
                    <div class="arrow-separator">
                        <i class="material-icons">arrow_forward</i>
                    </div>
                    <div class="price-wrapper">
                        <div class="price-label">{{ $t("message.totalPrice") }}</div>
                        <div class="price-value">
                            <MoneyFormatter :price="totalPrice" :className="total-price" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Kalan hak uyarısı -->
            <div class="remaining-warning" v-if="remainingSessionCount > 0">
                <div class="remaining-warning-icon">
                    <i class="material-icons">warning_amber</i>
                </div>
                <div class="remaining-warning-content">
                    <div class="remaining-warning-title">{{ $t("message.existingUsageRights") }}</div>
                    <div class="remaining-warning-text" v-html="$t('message.existingSessionRights', { count: remainingSessionCount.toLocaleString() })">
                    </div>
                    <div class="remaining-priority-list">
                        <div class="remaining-priority-item">
                            <span class="priority-badge free">1</span>
                            <span class="priority-label">{{ $t("message.freeRights") }}</span>
                            <span class="priority-value free">{{ (features.freeSessionCount || 0).toLocaleString() }}</span>
                        </div>
                        <div class="remaining-priority-item">
                            <span class="priority-badge normal">2</span>
                            <span class="priority-label">{{ $t("message.normalPackage") }}</span>
                            <span class="priority-value normal">{{ normalSessionCount.toLocaleString() }}</span>
                        </div>
                        <div class="remaining-priority-item">
                            <span class="priority-badge extra">3</span>
                            <span class="priority-label">{{ $t("message.extraPackage") }}</span>
                            <span class="priority-value extra">{{ (features.extraSessionCount || 0).toLocaleString() }}</span>
                        </div>
                    </div>
                    <div class="remaining-warning-note">
                        {{ $t("message.usageOrderNote") }}
                    </div>
                </div>
            </div>

            <div class="warning-message" v-if="sessionCount > 0">
                <div class="warning-icon">
                    <i class="material-icons">info</i>
                </div>
                <div class="warning-content">
                    <div class="warning-title">{{ $t("message.importantInfo") }}</div>
                    <div class="warning-text" v-html="$t('message.packageEndsInfo', { date: endOfMonthDate })">
                    </div>
                </div>
            </div>

            <div class="footer">
                <SupsisButton class="footer-btn cancel-btn" @click="cancel">{{ $t("common.cancel") }}</SupsisButton>
                <SupsisButton class="footer-btn primary-btn" primary @click="confirm" :disabled="sessionCount <= 0">
                    <i class="material-icons">check_circle</i>
                    <span>{{ $t("message.buy") }}</span>
                </SupsisButton>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import MoneyFormatter from "../MoneyFormatter.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
import { mapState } from "vuex";
import moment from "moment";
import "moment/locale/tr";

const sessionAndPricing = [
    [300, 2.5],
    [500, 1.5],
    [1000, 1.25],
    [2500, 1],
    [5000, 0.7998],
    [10000, 0.75],
    [15000, 0.833333333],
    [20000, 0.6],
    [25000, 0.75],
    [40000, 0.7375],
    [50000, 0.7],
    [75000, 0.6],
    [100000, 0.52],
    [250000, 0.48],
    [500000, 0.42],
    [1000000, 0.35],
];

const taskAndPricing = [
    [750, 0.9088],
    [1500, 0.8905],
    [2000, 0.8391],
    [5000, 0.6097],
    [10000, 0.4418],
    [20000, 0.3237],
    [50000, 0.198],
    [100000, 0.1675],
    [200000, 0.1317],
    [300000, 0.122],
    [400000, 0.1087],
    [500000, 0.1027],
    [750000, 0.0913],
    [1000000, 0.0753],
    [1250000, 0.0712],
    [1500000, 0.0685],
    [1750000, 0.0626],
    [2000000, 0.058],
];

/**
 * 19.9$ => 750 task
 * 39$ => 1500 task
 * 49$ => 2000 task
 * 89$ => 5000 task
 * 129$ => 10000 task
 * 189$ => 20000 task
 * 289$ => 50000 task
 * 489$ => 100000 task
 * 769$ => 200000 task
 * 1069$ => 300000 task
 * 1269$ => 400000 task
 * 1499$ => 500000 task
 * 1999$ => 750000 task
 * 2199$ => 1000000 task
 * 2599$ => 1250000 task
 * 2999$ => 1500000 task
 * 3199$ => 1750000 task
 * 3389$ => 2000000 task
 */

/**
 * Ekstra Chatbot satın alma modalı
 * Kullanıcıya ekstra session paketi satın alma imkanı sunar
 * v3 design kullanarak modern bir arayüz sağlar
 */
export default {
    name: "ExtraPlanModal",
    components: {
        Modal,
        MoneyFormatter,
        SupsisButton,
    },
    data: () => ({
        sessionCount: 0,
        totalPrice: 0,
        timeout: null,
    }),
    computed: {
        ...mapState({
            features: (state) => state.site.features || {},
            totalChatbotUsage: (state) => state.site.conversationStatistics.totalChatbotUsage || 0,
        }),
        /**
         * Ayın son gününü hesaplar ve formatlanmış tarih döndürür
         * @returns {String} Formatlanmış tarih (örn: "31 Aralık 2024")
         */
        endOfMonthDate() {
            return moment()
                .locale("tr")
                .endOf("month")
                .format("DD MMMM YYYY");
        },
        /**
         * Kalan toplam session sayısını hesaplar
         * @returns {Number}
         */
        remainingSessionCount() {
            return Math.max(0, (this.features.totalSessionCount || 0) - this.totalChatbotUsage);
        },
        /**
         * Normal (chatbot) paketindeki session sayısını hesaplar
         * @returns {Number}
         */
        normalSessionCount() {
            var free = this.features.freeSessionCount || 0;
            var extra = this.features.extraSessionCount || 0;
            return Math.max(0, (this.features.maxSessionCount || 0) - free - extra);
        },
    },
    methods: {
        /**
         * Modal'ı kapatır ve close event'i emit eder
         */
        cancel() {
            this.$emit("close");
        },
        /**
         * Satın alma işlemini onaylar ve confirm event'i ile session sayısını emit eder
         */
        confirm() {
            if (this.sessionCount <= 0) return;
            this.$emit("confirm", parseInt(this.sessionCount));
        },
        /**
         * Session sayısına göre toplam fiyatı hesaplar
         * Lineer interpolasyon kullanarak fiyatlandırma yapar
         * @returns {Number} Hesaplanan toplam fiyat
         */
        calculateSessionPrice() {
            const sessionCount = this.sessionCount;
            const isLastSession = sessionCount > sessionAndPricing[sessionAndPricing.length - 1][0];
            const x2Index = sessionAndPricing.findIndex(
                (session) => session[0] >= sessionCount && sessionCount <= session[0]
            );
            const x1Index = Math.max(x2Index - 1, 0);
            const [x1, y1] = sessionAndPricing[isLastSession ? sessionAndPricing.length - 1 : x1Index];
            const [x2, y2] = sessionAndPricing[isLastSession ? sessionAndPricing.length - 1 : x2Index];
            return (y1 + ((sessionCount - x1) * (y2 - y1)) / Math.max(x2 - x1, 1)) * sessionCount;
        },
    },
    watch: {
        /**
         * Session sayısı değiştiğinde fiyatı yeniden hesaplar
         * Debounce kullanarak performansı optimize eder
         */
        sessionCount() {
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.totalPrice = this.calculateSessionPrice();
            }, 200);
        },
    },
};
</script>
<style lang="scss">
// Ana renk değişkeni
$primary-color: #5625cc;
$primary-color-light: rgba(86, 37, 204, 0.08);
$primary-color-hover: rgba(86, 37, 204, 0.12);

.extra-plan-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 8px 0;

    .header-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 36px;

        .icon-wrapper {
            width: 64px;
            height: 64px;
            border-radius: 16px;
            background: $primary-color;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            box-shadow: 0 4px 16px rgba(86, 37, 204, 0.25);

            .material-icons {
                font-size: 32px;
                color: white;
            }
        }

        .title {
            font-weight: 700;
            font-size: 24px;
            text-align: center;
            color: var(--text-main-default, #121317);
            margin-bottom: 8px;
            letter-spacing: -0.3px;
        }

        .subtitle {
            font-size: 14px;
            font-weight: 400;
            color: var(--text-main-subdued, #5a5f72);
            text-align: center;
            line-height: 1.5;
        }
    }

    .suggestion-sessions {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        width: 100%;
        max-width: 500px;
        margin-bottom: 32px;
        justify-content: center;

        .suggestion-item {
            padding: 12px 20px;
            border: 1.5px solid var(--border-neutral-default, #c7d0d7);
            border-radius: 10px;
            cursor: pointer;
            user-select: none;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            background: white;
            font-size: 14px;
            font-weight: 600;
            color: var(--text-main-default, #121317);
            min-width: 70px;
            text-align: center;
            position: relative;

            &:hover {
                border-color: $primary-color;
                background: $primary-color-light;
                color: $primary-color;
                transform: translateY(-1px);
                box-shadow: 0 2px 8px rgba(86, 37, 204, 0.15);
            }

            &.selected {
                background: $primary-color;
                border-color: $primary-color;
                color: white;
                box-shadow: 0 4px 12px rgba(86, 37, 204, 0.3);
                transform: translateY(-1px);
            }
        }
    }

    .custom-input-section {
        width: 100%;
        max-width: 500px;
        margin-bottom: 28px;

        .input-container {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 20px 24px;
            background: white;
            border: 1.5px solid var(--border-neutral-default, #c7d0d7);
            border-radius: 14px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

            &:hover {
                border-color: $primary-color;
                box-shadow: 0 4px 16px rgba(86, 37, 204, 0.12);
            }

            .input-wrapper {
                flex: 1;
                display: flex;
                align-items: center;
                gap: 14px;

                .input-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    background: $primary-color-light;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;

                    .material-icons {
                        font-size: 20px;
                        color: $primary-color;
                    }
                }

                .input-content {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    gap: 6px;

                    .input-label {
                        font-size: 12px;
                        font-weight: 600;
                        color: var(--text-main-subdued, #5a5f72);
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }

                    .custom-input {
                        .ant-input-number {
                            width: 100%;
                            border: none;
                            box-shadow: none;
                            background: transparent;

                            .ant-input-number-input {
                                font-size: 17px;
                                font-weight: 600;
                                color: var(--text-main-default, #121317);
                                padding: 0;
                                height: auto;
                            }

                            &:hover,
                            &:focus-within {
                                border: none;
                                box-shadow: none;
                            }
                        }
                    }
                }
            }

            .arrow-separator {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 32px;
                height: 32px;
                border-radius: 8px;
                background: var(--base-gray-100, #fafbfc);
                flex-shrink: 0;

                .material-icons {
                    font-size: 20px;
                    color: var(--text-main-subdued, #5a5f72);
                }
            }

            .price-wrapper {
                display: flex;
                flex-direction: column;
                gap: 6px;
                align-items: flex-end;
                min-width: 120px;
                padding-left: 16px;
                border-left: 1.5px solid var(--border-neutral-default, #c7d0d7);

                .price-label {
                    font-size: 12px;
                    font-weight: 600;
                    color: var(--text-main-subdued, #5a5f72);
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .price-value {
                    .total-price {
                        font-weight: 700;
                        font-size: 22px;
                        color: $primary-color;
                        line-height: 1.2;
                        white-space: nowrap;
                    }
                }
            }
        }
    }

    .remaining-warning {
        display: flex;
        align-items: flex-start;
        gap: 14px;
        width: 100%;
        max-width: 500px;
        margin-bottom: 16px;
        padding: 16px;
        background: rgba(86, 37, 204, 0.04);
        border-radius: 10px;
        border-left: 3px solid $primary-color;

        .remaining-warning-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border-radius: 8px;
            background: rgba(86, 37, 204, 0.1);
            flex-shrink: 0;

            .material-icons {
                font-size: 20px;
                color: $primary-color;
            }
        }

        .remaining-warning-content {
            flex: 1;
            padding-top: 2px;

            .remaining-warning-title {
                font-size: 14px;
                font-weight: 600;
                color: var(--text-main-default, #121317);
                margin-bottom: 6px;
            }

            .remaining-warning-text {
                font-size: 13px;
                line-height: 1.6;
                color: var(--text-main-subdued, #5a5f72);
                margin-bottom: 12px;

                strong {
                    color: $primary-color;
                    font-weight: 600;
                }
            }

            .remaining-priority-list {
                display: flex;
                flex-direction: column;
                gap: 6px;
                margin-bottom: 10px;

                .remaining-priority-item {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 12px;

                    .priority-badge {
                        width: 20px;
                        height: 20px;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 10px;
                        font-weight: 700;
                        flex-shrink: 0;
                        color: white;

                        &.free { background: #10B981; }
                        &.normal { background: $primary-color; }
                        &.extra { background: #F59E0B; }
                    }

                    .priority-label {
                        flex: 1;
                        color: var(--text-main-subdued, #5a5f72);
                        font-weight: 500;
                    }

                    .priority-value {
                        font-weight: 700;
                        font-size: 13px;

                        &.free { color: #10B981; }
                        &.normal { color: $primary-color; }
                        &.extra { color: #F59E0B; }
                    }
                }
            }

            .remaining-warning-note {
                font-size: 11px;
                color: #9CA3AF;
                font-style: italic;
            }
        }
    }

    .warning-message {
        display: flex;
        align-items: flex-start;
        gap: 14px;
        width: 100%;
        max-width: 500px;
        margin-bottom: 28px;
        padding: 16px;
        background: rgba(255, 193, 7, 0.06);
        border-radius: 10px;
        border-left: 3px solid #f09a0f;

        .warning-icon {
            display: flex;
        align-items: center;
        justify-content: center;
            width: 36px;
            height: 36px;
            border-radius: 8px;
            background: rgba(255, 193, 7, 0.12);
            flex-shrink: 0;

            .material-icons {
                font-size: 20px;
                color: #f09a0f;
            }
        }

        .warning-content {
            flex: 1;
            padding-top: 2px;

            .warning-title {
                font-size: 14px;
                font-weight: 600;
                color: var(--text-main-default, #121317);
                margin-bottom: 6px;
            }

            .warning-text {
                font-size: 13px;
                line-height: 1.6;
                color: var(--text-main-subdued, #5a5f72);

                strong {
                    color: $primary-color;
                    font-weight: 600;
                }
            }
        }
    }

    .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        width: 100%;
        max-width: 500px;
        margin-top: 8px;

        .footer-btn {
            flex: 1;
            height: 44px;
            border-radius: 8px;
            font-weight: 600;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            transition: all 0.2s ease;

            &.cancel-btn {
                background: var(--base-gray-100, #fafbfc);
                color: var(--text-main-default, #121317);
                border: 1px solid var(--border-neutral-default, #c7d0d7);

                &:hover {
                    background: var(--base-gray-200, #f6f8f9);
                }
            }

            &.primary-btn {
                background: $primary-color;
                color: white;
                border: none;
                box-shadow: 0 2px 8px rgba(86, 37, 204, 0.3);

                &:hover:not(:disabled) {
                    background: darken($primary-color, 5%);
                    box-shadow: 0 4px 12px rgba(86, 37, 204, 0.4);
                }

                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }

                .material-icons {
                    font-size: 18px;
                }
            }
        }
    }
}

// Responsive tasarım
@media (max-width: 768px) {
    .extra-plan-content {
        .suggestion-sessions {
            gap: 6px;

            .suggestion-item {
                padding: 8px 14px;
                font-size: 13px;
            }
        }

        .custom-input-section {
            .input-container {
                flex-direction: column;
                gap: 16px;
                padding: 20px;

                .arrow-separator {
                    transform: rotate(90deg);
                }

                .price-wrapper {
                    width: 100%;
                    min-width: auto;
                    align-items: flex-start;
                    padding-left: 0;
                    border-left: none;
                    border-top: 1.5px solid var(--border-neutral-default, #c7d0d7);
                    padding-top: 16px;
                }
            }
        }

        .footer {
            flex-direction: column;

            .footer-btn {
                width: 100%;
            }
        }
    }
}
</style>




